export const initAds = () => {
  googletag.cmd.push(() => {
    googletag.pubads().enableSingleRequest()
    googletag.enableServices()
  })
}
